import { render, staticRenderFns } from "./nxMobileDivider.vue?vue&type=template&id=b290bc06&scoped=true&"
import script from "./nxMobileDivider.vue?vue&type=script&lang=js&"
export * from "./nxMobileDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b290bc06",
  null
  
)

export default component.exports